__turbopack_context__.v({
  "container": "Uu8sbq_container",
  "icon": "Uu8sbq_icon",
  "message": "Uu8sbq_message",
  "slideInAnimation": "Uu8sbq_slideInAnimation",
  "title": "Uu8sbq_title",
});
